import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// 未配置时返回 null，避免 createClient('', '') 抛异常导致白屏
// 用 PKCE 流程：OAuth 回调走 ?code=... query param，不污染 location.hash
// （PrimaryLens 用 hash 做路由，默认的 implicit 流程会和路由打架）
export const supabase = SUPABASE_URL && SUPABASE_ANON_KEY
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        flowType: 'pkce',
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null;
